import { UrlHelpers } from '../../service/UrlHelpers';
import { BatchesCollection, TriState } from '../BatchesList/typings';
import { Html5CreativesApiResponse, UploadHtml5Response } from '../common/requestsTypings';
import { UploadCreative, UploadStatus } from '../Html5Upload/typings';

export function createCreativesCollection(response: Html5CreativesApiResponse): BatchesCollection {
    return {
        batches: response.items.map(batch => {
            const batchItems = batch.creatives.map(item => {
                return {
                    id: item.id,
                    name: batch.name,
                    batchId: batch.id,
                    creativeURL: item.preview_url,
                    screenshotURL: item.screenshot_url,
                    archiveURL: item.archive_url,
                    previewURL: UrlHelpers.getHTML5CreativePreviewUrl('canvas', item.id.toString()),
                    selected: false,
                    fitsSizeFilter: true,
                    data: {
                        width: item.width,
                        height: item.height,
                        isAdaptive: false
                    }
                };
            });

            return {
                id: batch.id,
                thumbnail: batchItems.length ? batchItems[0].screenshotURL : '',
                selected: TriState.FALSE,
                name: batch.name,
                total: batchItems.length,
                filteredBySizeTotal: batchItems.length,
                items: batchItems
            };
        }),
        total: response.total
    };
}

export function createUploadCreative(creative: UploadCreative, resp: UploadHtml5Response): UploadCreative {
    if (resp.messages) {
        return {
            status: UploadStatus.ERROR,
            fileId: creative.fileId,
            name: creative.name,
            errors: resp.messages
        };
    }
    return {
        fileId: creative.fileId,
        status: UploadStatus.SUCCESS,
        id: resp.id,
        name: resp.name,
        thumbnailUrl: resp.screenshot_url,
        creativeUrl: resp.preview_url,
        width: resp.width,
        height: resp.height
    };
}
